const ClaimTypes = [
    {value: "0", name: "Please select"},
    {value: "1", name: "Fire - Dropped Light Or Cigarette"},
    {value: "2", name: "Fire - Electrical Fault"},
    {value: "3", name: "Fire - Arson Or Malicious Fire By Tenant"},
    {value: "4", name: "Fire - Arson Or Malicious Fire - Not By Tenant"},
    {value: "5", name: "Fire - Any Other Cause"},
    {value: "6", name: "Lightning"},
    {value: "7", name: "Explosion"},
    {value: "8", name: "Aircraft Or Items Dropped Therefrom"},
    {value: "9", name: "Terrorism"},
    {value: "10", name: "Storm - Wind Damage"},
    {value: "11", name: "Storm - Water Damage"},
    {value: "12", name: "Storm - Any Other Cause"},
    {value: "13", name: "Flood - Sea"},
    {value: "14", name: "Flood - River Or Inland Waterway"},
    {value: "15", name: "Water Damage - Burst Or Leaking Pipes Or Appliances"},
    {value: "16", name: "Water Damage - Cost Of Tracing & Repairing Leaks"},
    {value: "17", name: "Water Damage - Any Other Cause"},
    {value: "18", name: "Riot Or Civil Commotion"},
    {value: "19", name: "Malicious Damage (not Fire) By Tenant"},
    {value: "20", name: "Malicious Damage (not Fire) - Not By Tenant"},
    {value: "21", name: "Malicious Damage (not Fire) - Any Other Cause"},
    {value: "22", name: "Earthquake"},
    {value: "23", name: "Impact Or Collision By Vehicle"},
    {value: "24", name: "Impact Or Collision Any Other Cause (not Aircraft)"},
    {value: "25", name: "Subsidence Or Land Slip"},
    {value: "26", name: "Ground Heave"},
    {value: "27", name: "Theft Of Fixtures & Fittings Following Breakin"},
    {value: "28", name: "Theft Of Fixtures & Fittings Not Following Breakin"},
    {value: "29", name: "Theft Of Contents Following Breakin"},
    {value: "30", name: "Theft Of Contents Not Following Breakin"},
    {value: "31", name: "Accidental Damage To Glass In Buildings"},
    {value: "32", name: "Accidental Damage To Glass In Furniture"},
    {value: "33", name: "Accidental Damage To Bathroom Fixtures & Fittings"},
    {value: "34", name: "Accidental Damage To Service Pipes & Cables"},
    {value: "35", name: "Liability As Property Owner"},
    {value: "36", name: "Liability As Owner Of Contents"},
    {value: "37", name: "Liability - Injury To Employees"},
    {value: "38", name: "Liability - Other"},
    {value: "39", name: "Falling Trees"},
    {value: "40", name: "Oil Leakage"},
    {value: "41", name: "Loss Of Rent Following Damage To Buildings"},
    {value: "42", name: "Loss Of Rent Following Damage To The Contents"},
    {value: "43", name: "Rent Guarantee - Non Payment By Tenant"},
    {value: "44", name: "Legal Expenses - Tenant Default On Rent"},
    {value: "45", name: "Legal Expenses - Eviction Of Tenants"},
    {value: "46", name: "Legal Expenses - Eviction Of Unauthorised Occupants"},
    {value: "47", name: "Loss Of Keys"},
    {value: "48", name: "Theft Of Keys"},
    {value: "49", name: "Loss Of Metered Water"},
    {value: "50", name: "Loss Of Metered Gas"},
    {value: "88", name: "Accidental Damage To Tv Or Audio Equipment"},
    {value: "89", name: "Other Accidental Damage"},
    {value: "90", name: "Personal Liability"},
    {value: "91", name: "Employers Liability"},
    {value: "93", name: "Falling Trees"},
    {value: "94", name: "Oil Leakage"},
    {value: "95", name: "Cost Of Alternative Accommodation Following Claim"},
    {value: "96", name: "Frozen Food"},
    {value: "97", name: "Loss Of Credit Card"},
    {value: "98", name: "Loss/damage - Personal Possessions Away FROM The Home"},
    {value: "99", name: "Loss/damage - Pedal Cycles Away FROM The Home"},
];

export default ClaimTypes;



/** WEBPACK FOOTER **
 ** ./src/components/Data/ClaimTypes.js
 **/